import React from 'react';
import { announcements, navbarItems } from './constants';
import {
  AnnouncementTag,
  PreviewWrapper,
  NotificationTag,
  Date,
  BorderBar,
} from './StyledColorComponents';
import searchIcon from '@/assets/pink-one/search.svg';
import styles from './index.module.scss';

const AppPreview = ({ bgColor, sysColor, logoUrl }) => {
  return (
    <PreviewWrapper bgColor={bgColor}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <img src={logoUrl} alt="logo" width={32} height={32} />
          </div>
          <div className={styles.searchContainer}>
            <div className={styles.searchIcon}>
              <img src={searchIcon} alt="searchIcon" width={19} height={19} />
            </div>
            <div className={styles.searchTxt}>搜尋</div>
          </div>
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.title}>公佈欄</div>
          <div className={styles.moreContainer}>
            <div>更多</div>
            <div className={styles.moreIcon}></div>
          </div>
        </div>
        <div className={styles.announcementItemWrapper}>
          {announcements.map((announcement, index) => {
            const {
              tag: { bgColor, txt },
              content,
              notificationNum,
              date,
            } = announcement;
            return (
              <div className={styles.announcementItemContainer} key={index}>
                <AnnouncementTag bgColor={bgColor}>{txt}</AnnouncementTag>
                <div className={styles.contentContainer}>
                  <div className={styles.content}>{content}</div>
                  {notificationNum !== '' ? (
                    <NotificationTag sysColor={sysColor}>
                      {notificationNum}
                    </NotificationTag>
                  ) : null}
                </div>
                <div
                  className={date !== '12/11' ? styles.date : styles.date_mr10}
                >
                  {date}
                </div>
              </div>
            );
          })}
          <div className={styles.announcementNumber}>還有0則</div>
        </div>
        <div className={styles.calendarTitleContainer}>
          <div className={styles.title}>行事曆</div>
          <div className={styles.moreContainer}>
            <div>更多</div>
            <div className={styles.moreIcon}></div>
          </div>
        </div>
        <div className={styles.calendarWrapper}>
          <div className={styles.todayContainer}>
            <Date sysColor={sysColor}>12月14日 星期一</Date>
          </div>
          <div className={styles.itemWrapper}>
            <BorderBar sysColor={sysColor} />
            <div className={styles.itemContainer}>
              <div className={styles.calendarTxt}>打掃服務</div>
              <div className={styles.calendarTime}>10:00 ~ 11:00</div>
            </div>
          </div>
          <div className={styles.itemWrapper}>
            <BorderBar sysColor={sysColor} />
            <div className={styles.itemContainer}>
              <div className={styles.calendarTxt}>有氧瑜伽課程</div>
              <div className={styles.calendarTime}>14:00 ~ 15:00</div>
            </div>
          </div>
          <div className={styles.announcementNumber}>還有1則</div>
        </div>
        <div className={styles.navbarWrapper}>
          <div className={styles.navbarContainer}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 71.84 70.2"
            >
              <g id="首頁粉-11" transform="translate(-6.6 -7.42)">
                <path
                  id="Path_216"
                  data-name="Path 216"
                  d="M76.44,75.62H8.6V36.29l.28-.23L42.05,9.79l.47-.37.47.37L76.16,36.06l.28.23Z"
                  fill={sysColor}
                  stroke={sysColor}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4"
                />
                <rect
                  id="Rectangle_278"
                  data-name="Rectangle 278"
                  width="23.08"
                  height="33.93"
                  transform="translate(30.98 35.18)"
                  fill="none"
                />
                <rect
                  id="Rectangle_279"
                  data-name="Rectangle 279"
                  width="23.08"
                  height="13.15"
                  transform="translate(30.98 35.18)"
                  fill="none"
                />
                <path
                  id="Path_217"
                  data-name="Path 217"
                  d="M32.35,67.28V51.16a10.17,10.17,0,0,1,20.34,0V67.28"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="4"
                />
              </g>
            </svg>
            <div className={styles.navbarTxt}>首頁</div>
          </div>

          {navbarItems.map((item) => {
            return (
              <div className={styles.navbarContainer} key={item.alt}>
                {item.alt !== 'message' ? (
                  <img
                    src={item.url}
                    alt="HomePage-pink"
                    className={styles.navbarIcon}
                  />
                ) : (
                  <div className={styles.iconWrapper}>
                    <img
                      src={item.url}
                      alt="HomePage-pink"
                      className={styles.navbarIcon}
                    />
                    <div className={styles.redCircle}></div>
                  </div>
                )}
                <div className={styles.navbarTxt}>{item.txt}</div>
              </div>
            );
          })}
        </div>
      </div>
    </PreviewWrapper>
  );
};

export default AppPreview;
